import { store } from '../root/ReduxStore.store';
import { onRefreshToken, logOut } from '../user-auth/userAuth.slice';

export const refreshAccessToken = async () => {
  const state = store.getState();
  const refreshToken = state.userAuth.refreshToken;
  const accessToken = state.userAuth.token;
  const workspaceId = state.userAuth.workspace?.id ?? '';

  const response = await fetch('https://api-qa.zotok.ai/regenerate/token', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      refreshToken,
      token: accessToken,
      workspaceId,
    }),
  });

  if (!response.ok) {
    store.dispatch(logOut());
    throw new Error('Failed token refresh');
  }

  const tokens = await response.json();

  store.dispatch(onRefreshToken(tokens));

  return tokens.accessToken;
};
